<template>
    <v-container fluid class="pa-4">
        <v-card class="mb-4">
            <v-card-title class="text-h6">
                <v-icon left color="primary">mdi-chart-bar</v-icon>
                Performance Review
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="openNew">
                    <v-icon left small>mdi-plus</v-icon>Nuova review
                </v-btn>
                <v-btn icon class="ml-2" @click="load" :loading="loading"><v-icon>mdi-refresh</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <v-row align="center" dense>
                    <v-col cols="12" md="4">
                        <v-autocomplete v-model="filterEmployee" :items="employees" item-text="text" item-value="value" label="Dipendente" prepend-icon="mdi-account-tie" outlined dense hide-details clearable @change="load"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model.number="filterYear" type="number" label="Anno" prepend-icon="mdi-calendar" outlined dense hide-details @change="load"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-data-table :headers="headers" :items="items" :loading="loading" :items-per-page="25">
                <template v-slot:item.period="{ item }">{{ item.period_year }}{{ item.period_quarter ? ' · Q' + item.period_quarter : '' }}</template>
                <template v-slot:item.overall_rating="{ item }">
                    <v-rating v-if="item.overall_rating" :value="parseFloat(item.overall_rating)" readonly half-increments dense small color="amber" :length="5" background-color="grey lighten-2"></v-rating>
                    <span v-else class="grey--text">—</span>
                </template>
                <template v-slot:item.status="{ item }">
                    <v-chip small :color="statusColor(item.status)" text-color="white">{{ statusText(item.status) }}</v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn v-if="$store.getters.canActOn('hrperformancereviews', 'show', item)" icon small @click="openDetail(item)" title="Dettaglio"><v-icon small>mdi-eye</v-icon></v-btn>
                    <v-btn v-if="item.status !== 'signed' && $store.getters.canActOn('hrperformancereviews', 'edit', item)" icon small color="success" @click="sign(item)" title="Firma"><v-icon small>mdi-draw</v-icon></v-btn>
                </template>
            </v-data-table>
        </v-card>

        <!-- Dialog nuova/modifica review con obiettivi inline -->
        <v-dialog v-model="dialog" max-width="800">
            <v-card>
                <v-card-title><v-icon left color="primary">mdi-chart-bar</v-icon>Nuova Performance Review</v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-autocomplete v-model="form.employee_id" :items="employees" item-text="text" item-value="value" label="Dipendente" prepend-icon="mdi-account-tie" outlined dense></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete v-model="form.reviewer_employee_id" :items="employees" item-text="text" item-value="value" label="Reviewer" prepend-icon="mdi-account-eye" outlined dense></v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-text-field v-model.number="form.period_year" type="number" label="Anno" prepend-icon="mdi-calendar" outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-select v-model="form.period_quarter" :items="[{value:null,text:'Annuale'},{value:1,text:'Q1'},{value:2,text:'Q2'},{value:3,text:'Q3'},{value:4,text:'Q4'}]" label="Periodo" prepend-icon="mdi-calendar-range" outlined dense></v-select>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model.number="form.overall_rating" type="number" step="0.1" min="0" max="5" label="Rating (0-5)" prepend-icon="mdi-star" outlined dense></v-text-field>
                        </v-col>
                    </v-row>
                    <v-textarea v-model="form.strengths" label="Punti di forza" prepend-icon="mdi-thumb-up" outlined dense rows="2" auto-grow></v-textarea>
                    <v-textarea v-model="form.improvements" label="Aree di miglioramento" prepend-icon="mdi-trending-up" outlined dense rows="2" auto-grow></v-textarea>

                    <v-divider class="my-3"></v-divider>
                    <div class="d-flex align-center mb-2">
                        <div class="text-subtitle-2">Obiettivi (OKR/KPI)</div>
                        <v-spacer></v-spacer>
                        <v-btn small text @click="addGoal"><v-icon left small>mdi-plus</v-icon>Aggiungi</v-btn>
                    </div>
                    <div v-for="(g, i) in form.goals" :key="i" class="mb-2">
                        <v-row dense>
                            <v-col cols="12" md="5">
                                <v-text-field v-model="g.title" label="Obiettivo" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" md="2">
                                <v-text-field v-model="g.metric" label="Metrica" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" md="2">
                                <v-text-field v-model.number="g.target" type="number" label="Target" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" md="2">
                                <v-text-field v-model.number="g.actual" type="number" label="Attuale" dense outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6" md="1" class="d-flex align-center">
                                <v-btn icon small color="error" @click="form.goals.splice(i,1)"><v-icon small>mdi-delete</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" :loading="saving" @click="save">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog dettaglio con goals -->
        <v-dialog v-model="detailDialog" max-width="700">
            <v-card v-if="detail">
                <v-card-title><v-icon left color="primary">mdi-chart-bar</v-icon>Review dettaglio</v-card-title>
                <v-card-text>
                    <div class="text-subtitle-2">{{ detail.employee ? detail.employee.first_name + ' ' + detail.employee.last_name : '' }} · {{ detail.period_year }}{{ detail.period_quarter ? ' Q' + detail.period_quarter : '' }}</div>
                    <v-rating v-if="detail.overall_rating" :value="parseFloat(detail.overall_rating)" readonly half-increments dense small color="amber" :length="5"></v-rating>
                    <v-divider class="my-2"></v-divider>
                    <div class="text-body-2 mb-2"><strong>Punti di forza:</strong> {{ detail.strengths }}</div>
                    <div class="text-body-2 mb-3"><strong>Miglioramenti:</strong> {{ detail.improvements }}</div>
                    <div class="text-subtitle-2 mb-1">Obiettivi</div>
                    <v-simple-table dense>
                        <thead>
                            <tr><th>Titolo</th><th>Metrica</th><th>Target</th><th>Attuale</th><th>Peso</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="g in (detail.goals || [])" :key="g.id">
                                <td>{{ g.title }}</td>
                                <td>{{ g.metric }}</td>
                                <td>{{ g.target }}</td>
                                <td>{{ g.actual }}</td>
                                <td>{{ g.weight }}%</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="detailDialog = false">Chiudi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    export default {
        name: 'hr-performance-reviews',

        data() {
            return {
                items: [],
                employees: [],
                filterEmployee: null,
                filterYear: new Date().getFullYear(),
                loading: false,
                saving: false,
                dialog: false,
                form: this.emptyForm(),
                detailDialog: false,
                detail: null,
                headers: [
                    { text: 'Dipendente', value: 'employee_full_name' },
                    { text: 'Periodo', value: 'period' },
                    { text: 'Rating', value: 'overall_rating' },
                    { text: 'Stato', value: 'status' },
                    { text: '', value: 'actions', sortable: false, align: 'end' },
                ],
            }
        },

        methods: {
            emptyForm() { return { employee_id: null, reviewer_employee_id: null, period_year: new Date().getFullYear(), period_quarter: null, status: 'draft', overall_rating: null, strengths: '', improvements: '', goals: [] } },
            load() {
                this.loading = true
                const payload = {}
                if (this.filterEmployee) payload.employee_id = this.filterEmployee
                if (this.filterYear) payload.year = this.filterYear
                this.axios.post('hrperformancereviews-filters', payload).then(r => { this.items = r.data.data || []; this.loading = false }, () => { this.loading = false })
            },
            loadEmployees() {
                this.axios.post('hremployees-filters').then(r => {
                    const data = r.data.data && r.data.data.data ? r.data.data.data : (Array.isArray(r.data.data) ? r.data.data : [])
                    this.employees = data.map(e => ({ value: e.id, text: `${e.first_name || ''} ${e.last_name || ''}`.trim() || `#${e.id}` }))
                })
            },
            openNew() { this.form = this.emptyForm(); this.dialog = true },
            addGoal() { this.form.goals.push({ title: '', metric: '', target: 0, actual: 0, weight: 100 }) },
            save() {
                this.saving = true
                this.axios.post('hrperformancereviews', this.form).then(() => { this.saving = false; this.dialog = false; this.load() }, () => { this.saving = false })
            },
            openDetail(item) {
                this.axios.get(`hrperformancereviews/${item.id}`).then(r => { this.detail = r.data.model; this.detailDialog = true })
            },
            sign(item) { this.axios.post(`hrperformancereviews/${item.id}/sign`).then(() => this.load()) },
            statusText(s) { return { draft: 'Bozza', shared: 'Condivisa', signed: 'Firmata' }[s] || s },
            statusColor(s) { return { draft: 'grey', shared: 'blue', signed: 'green' }[s] || 'grey' },
        },

        created() {
            this.$store.commit('endProgress')
            this.loadEmployees()
            this.load()
        },
    }
</script>
